import { component } from 'picoapp';

export default component((node) => {
  const articleList = node.querySelector<HTMLElement>('[data-blog-list]');
  const viewPrevBtn = node.querySelector<HTMLElement>('[data-view-prev-btn]');
  const viewMoreBtn = node.querySelector<HTMLElement>('[data-view-more-btn]');

  interface BlogConfig {
    sectionId: string,
  }

  interface ArticleListConfig {
    articles: number,
  }

  const blogConfig: BlogConfig = JSON.parse(node.dataset.config);
  const { sectionId } = blogConfig;

  const fetchSection = async (url: URL, updateUrl = true) => {
    const urlToFetch = url;

    if (updateUrl) {
      window.history.replaceState({}, '', urlToFetch);
    }

    urlToFetch.searchParams.set('section_id', sectionId);

    const response = await fetch(urlToFetch);
    const markup = await response.text();

    const container = document.createElement('div');
    container.innerHTML = markup;

    return container;
  };

  const loadNextPage = async () => {
    const url = new URL(window.location.href);
    const nextPage = parseInt(url.searchParams.get('page') || '1', 10) + 1;

    url.searchParams.set('page', nextPage.toString());

    const list = (await fetchSection(url as any)).querySelector<HTMLElement>('[data-blog-list]');
    const html = list.innerHTML;

    articleList.insertAdjacentHTML('beforeend', html);

    const articleListConfig: ArticleListConfig = JSON.parse(list.dataset.config);
    const { articles } = articleListConfig;

    if (nextPage >= articles) {
      viewMoreBtn.hidden = true;
    }
  };

  const loadPreviousPages = async () => {
    const url = new URL(window.location.href);
    const currentPage = parseInt(url.searchParams.get('page'), 10);

    const fetches = [];

    for (let page = 1; page < currentPage; page += 1) {
      url.searchParams.set('page', page.toString());
      fetches.push(fetchSection(url, false));
    }

    const html = (await Promise.all(fetches)).map((container) => (
      container.querySelector('[data-blog-list]')
    )).map((list) => (
      list.innerHTML
    )).join('');

    articleList.insertAdjacentHTML('afterbegin', html);

    if (viewPrevBtn) viewPrevBtn.hidden = true;
  };

  viewPrevBtn?.addEventListener('click', loadPreviousPages);
  viewMoreBtn?.addEventListener('click', loadNextPage);
});
